import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  min-width: 30px;
  height: 22px;
  background: rgba(247, 247, 247, 0.8);
  padding: 0 ${props => props.theme.space(2)};
  font-family: IntervalNextReg, sans-serif;
  font-weight: 500;
  font-size: ${props => props.theme.rem(14)};
  color: ${props => props.theme.card.primaryTextColor};
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  position: absolute;
  top: 13px;
`;
